import {
  ArrowLeftRight,
  Briefcase,
  Building2,
  ClipboardCheck,
  Code2,
  Flower2,
  GraduationCap,
  HeartHandshake,
  Languages,
  MessagesSquare,
  PenTool,
  PlaneTakeoff,
  Smile,
  UserCheck,
  type LucideIcon,
} from 'lucide-react'

const ICONS: Record<string, LucideIcon> = {
  ArrowLeftRight,
  Briefcase,
  Building2,
  ClipboardCheck,
  Code2,
  Flower2,
  GraduationCap,
  HeartHandshake,
  Languages,
  MessagesSquare,
  PenTool,
  PlaneTakeoff,
  Smile,
  UserCheck,
}

export function CourseIcon({ name, className }: { name: string; className?: string }) {
  const Icon = ICONS[name] ?? GraduationCap
  return <Icon className={className} aria-hidden />
}
